export const getInitialValues = (sortedFormFields: any[]) => {
    return sortedFormFields.reduce((values: any, field: any) => {
      if (field.field_type_id === 8) {
        const selectedOption = field.options?.find((option: { is_selected: any; }) => option.is_selected);
        values[field.label] = selectedOption ? selectedOption.value : "";
      } else if (field.field_type_id === 7) {
        values[field.label] = field.options
          ?.filter((option: { is_selected: any; }) => option.is_selected)
          .map((option: { value: any; }) => option.value) || [];
      } else if (field.field_type_id === 5) {
        const selectedOption = field.options?.find((option: { is_selected: any; }) => option.is_selected);
        values[field.label] = selectedOption ? selectedOption.value : "";
      } else if (field.field_type_id === 6) {
        values[field.label] = field.options
          ?.filter((option: { is_selected: any; }) => option.is_selected)
          .map((option: { value: any; }) => option.value) || [];
      } else {
        values[field.label] = field.value || "";
      }
      return values;
    }, {});
  };
  